export { type ImageWithContentProps, default as ImageWithContent } from './ImageWithContent';
